import {
  Injectable,
  EventEmitter
} from '@angular/core';


export enum StateInputFields {
  DELIVERY_MODE_NAME,
  DELIVERY_OPTION_VALUE_NAME,
  CONTRACT_ADDRESS_FORM_VALIDATE,
  CONTRACT_ADDRESS_FORM_VALUES,
  CONTRACT_ADDRESS_FORM_VALUES_STRING,
  CORRESPONDENCE_OTHER_ADDRESS_CHECKBOX,
  CORRESPONDENCE_OTHER_ADDRESS_FORM_VALIDATE,
  CORRESPONDENCE_OTHER_ADDRESS_FORM_VALUES,
  INSTALLATION_OTHER_ADDRESS_CHECKBOX,
  CORRESPONDENCE_OTHER_ADDRESS_VALUES,
  CORRESPONDENCE_OTHER_ADDRESS_STRING,
  INSTALLATION_OTHER_ADDRESS_FORM_VALIDATE,
  INSTALLATION_OTHER_ADDRESS_FORM_VALUES,
  SELECTED_POS,
  PAYMENT_INVOICE_FORM_VALIDATE,
  PAYMENT_INVOICE_ADDRESS_FORM_VALUES,
  PAYMENT_MODE_VALUE_NAME,
  IDENTITY_CONFIRMATION_TYPE,
  POS_PAYMENT_MODES,
  DELIVERY_COST
}

@Injectable()
export class FormStateChangeService {

  //for usage in AngularJS
  public StateInputFields = StateInputFields;

  private emitter: EventEmitter<FormStateChange> = new EventEmitter();

  setField(stateChange: FormStateChange) {
    this.emitter.emit(stateChange);
  }

  subscribe(callback: any) {
    return this.emitter.subscribe(callback);
  }
}

export class FormStateChange {
  constructor(public inputField: StateInputFields, public value: any){}
}
